import { observer } from "mobx-react";
import { useEffect } from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import LoaderInCenter from "../components/loaders/LoaderInCenter";
import AlarmView from "../pages/alarms/AlarmView";
import ContactGroupView from "../pages/contactGroups/ContactGroupView";
import ContactView from "../pages/contacts/ContactView";
import DeviceView from "../pages/device/DeviceView";
import HomeView from "../pages/home/HomeView";
import ScenarioView from "../pages/scenarios/ScenarioView";
import ContactGroupStore from "../store/ContactGroupStore";
import ContactStore from "../store/ContactStore";
import DeviceStore from "../store/DeviceStore";
import IncidentStore from "../store/IncidentStore";
import ScenarioStore from "../store/ScenarioStore";
import UserDataStore from "../store/UserDataStore";
import { NavLink } from "./NavLinks";

const AppRouter = () => {
  const userData = UserDataStore.currentUser;

  useEffect(() => {
    if (userData) {
      IncidentStore.subscribeIncidents();
      DeviceStore.subscribeDevices();
      ContactStore.subscribeContacts();
      ScenarioStore.subscribeScenarios();
      ContactGroupStore.subscribeContactGroups();
    }
    return () => {
      IncidentStore.unsubscribeIncidents &&
        IncidentStore.unsubscribeIncidents();
      DeviceStore.unsubscribeDevices && DeviceStore.unsubscribeDevices();
      ContactStore.unsubscribeContacts && ContactStore.unsubscribeContacts();
      ScenarioStore.unsubscribeScenarios &&
        ScenarioStore.unsubscribeScenarios();
      ContactGroupStore.unsubscribeContactGroups &&
        ContactGroupStore.unsubscribeContactGroups();
    };
  }, [userData]);

  if (!userData) return <LoaderInCenter />;

  return (
    <Switch>
      <Route path={NavLink.START} component={HomeView} exact />
      <Route path={NavLink.ALARMS} component={AlarmView} exact />
      <Route path={NavLink.DEVICES} component={DeviceView} exact />
      <Route path={NavLink.SCENARIOS} component={ScenarioView} exact />
      <Route path={NavLink.CONTACTS} component={ContactView} exact />
      <Route path={NavLink.CONTACT_GROUPS} component={ContactGroupView} exact />
      <Redirect to={NavLink.START} />
    </Switch>
  );
};

export default observer(AppRouter);
